<template>
  <!-- 蛋糕叔叔 订单确认 -->
  <div class='order'>
    <div class='card'>
      <div class='up'>
        <div class='div-img'>
          <img src='@/assets/img/uncle-cake-icon.png' alt='' />
        </div>
        <div class='rg'>
          <div>蛋糕鲜花</div>
          <div>{{ goodsName }}</div>
        </div>
      </div>
    </div>
    <div class='det'>
      <div class='add'>
        <div>订单金额</div>
        <div>¥ {{ saleAmount }}</div>
      </div>
      <van-divider />
      <div class='add'>
        <div>优惠金额</div>
        <div>¥ {{ discountAmount }}</div>
      </div>
      <van-divider />

      <van-divider />
      <div class='add'>
        <div>合计金额</div>
        <div class='rgt'>¥ {{ payAmount }}</div>
      </div>
    </div>
    <div class='note' v-html='description'></div>

    <div class='foot'>
      <div class='pri'>
        <div class='lf'>
          <span>合计：</span>
        </div>
        <div class='rg'>
          ¥{{ zs }}<span>.{{ xs }}</span>
        </div>
      </div>
      <div class='btn' @click='confirmPay'>确认支付</div>
    </div>
  </div>
</template>

<script>
import { uncleCakeToPay, getUncleCakeCustomDetails, getUncleCakeOrderConfirmInfo } from '@/api/uncleCake'

export default {
  name: 'UncleCakeOrderConfirm',
  data() {
    return {
      orderId: '', // 订单id
      goodsName: '', // 商品名称（第一个子订单商品名称）
      saleAmount: '', // 售价（元）
      discountAmount: '', // 折扣金额（元）
      payAmount: '', // 支付金额（元）
      description: '', // 充值说明
      zs: '',
      xs: ''
    }
  },
  created() {
    // 兼容 orderID / orderId 两种参数写法
    this.orderId = this.$route.query.orderID || this.$route.query.orderId || ''
    this.getDetail()
    this.getBusiDescription()
  },
  methods: {
    // 获取订单确认信息
    getDetail() {
      getUncleCakeOrderConfirmInfo({
        orderId: this.orderId
      }).then((res) => {
        if (!res) return
        if (res.code === 200 && res.data) {
          this.goodsName = res.data.goodsName // 商品名称（第一个子订单商品名称）
          this.saleAmount = res.data.saleAmount // 售价（元）
          this.discountAmount = res.data.discountAmount // 折扣金额（元）
          this.payAmount = res.data.payAmount // 支付金额（元）

          // 设置金额格式
          if (this.payAmount.toString().indexOf('.') !== -1) {
            this.zs = this.payAmount.toString().split('.')[0]
            this.xs = this.payAmount.toString().split('.')[1]
          } else {
            this.zs = this.payAmount
            this.xs = '00'
          }
        }
      })
    },
    // 确认支付
    confirmPay() {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      uncleCakeToPay({
        orderId: this.orderId
      })
        .then((res) => {
          this.$toast.clear()
          if (!res) return
          if (res.code === 200) {
            // 支付链接
            console.log('支付链接---》' + JSON.stringify(res))
            location.href = res.data
          }
        })
        .catch(() => {
          this.$toast.clear()
        })
    },
    // 获取充值说明
    getBusiDescription() {
      getUncleCakeCustomDetails().then((res) => {
        if (!res) return
        if (res.code === 200 && res.data) {
          this.description = res.data.details || ''
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.order {
  text-align: left;
  padding: 0.15rem;
  background-color: #f6f6f6;
  padding-bottom: 0.55rem;

  .card {
    width: 3.45rem;
    background: #ffffff;
    border-radius: 0.04rem;
    box-shadow: 0px 0.01rem 0.02rem 0px rgba(192, 192, 192, 0.08);
    padding: 0.15rem;
    box-sizing: border-box;

    .up {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .div-img {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 0.675rem;
        height: 0.675rem;

        img {
          width: 0.43rem;
          height: 0.43rem;
          border-radius: 0.08rem;
        }
      }

      .rg {
        padding: 0.08rem 0;
        margin-left: 0.2rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;

        div:first-child {
          font-size: 0.17rem;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 600;
          text-align: left;
          color: #333333;
          line-height: 0.185rem;
        }

        div:nth-child(2) {
          font-size: 0.17rem;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          text-align: left;
          color: #333333;
          line-height: 0.185rem;
          margin-top: 0.15rem;
        }
      }

      .goods-desc {
        font-size: 0.1rem;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 600;
        text-align: left;
        color: #999999;
        margin-top: 0.15rem;
        line-height: 0.185rem;
      }
    }
  }

  .det {
    margin-top: 0.15rem;
    width: 3.45rem;
    background: #ffffff;
    border-radius: 0.04rem;
    box-shadow: 0px 0.01rem 0.02rem 0px rgba(192, 192, 192, 0.08);
    padding-left: 0.2rem;
    padding-right: 0.15rem;
    box-sizing: border-box;

    ::v-deep .van-divider {
      margin: 0 0;
      font-size: 0;
      line-height: 0.5px;
    }

    .add {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 0.48rem;
      font-size: 0.16rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: left;
      color: #333333;
      line-height: 0.48rem;

      div:last-child {
        color: #333333;
        font-weight: 600;
        font-size: 0.16rem;
        font-family: PingFangSC, PingFangSC-Medium;
        line-height: 0.185rem;
        text-align: left;
      }

      div:last-child.rgt {
        color: #e90a0a;
      }
    }
  }

  .note {
    text-align: initial;
    margin-top: 0.15rem;
    margin-left: 0.15rem;
    font-size: 0.12rem;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    color: #e90a0a;
    white-space: pre-line;
    line-height: normal;
  }

  .foot {
    width: 3.75rem;
    height: 0.6rem;
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 0.1rem 0.15rem;
    background: #ffffff;
    box-shadow: 0.01rem 0px 0.02rem 0.01rem rgba(0, 0, 0, 0.04);
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;

    .pri {
      display: flex;
      align-items: flex-end;

      .lf {
        margin-bottom: 0.05rem;
        font-size: 0.16rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #999999;
        line-height: 0.165rem;

        span {
          color: #333;
        }
      }

      .rg {
        font-size: 0.21rem;
        font-family: PingFangSC, PingFangSC-Semibold;
        font-weight: 600;
        color: #e90a0a;
        line-height: 0.3rem;
        letter-spacing: 0.0056rem;
        vertical-align: bottom;

        span {
          font-size: 0.18rem;
        }
      }
    }

    .btn {
      width: 0.95rem;
      height: 0.35rem;
      background-image: linear-gradient(53deg, #f46264 0%, #fb8606 100%);
      border-radius: 0.175rem;
      background-size: contain;
      font-size: 0.16rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: center;
      color: #ffffff;
      line-height: 0.35rem;
    }
  }
}
</style>
